import useNavigation from "../../../../../hook/useNavigation";
import CartDetail from "../../../../../components/Cart";
import { cleanText } from "../../../../../utils/helper";

const ProductOption = ({
    cart = {},
    handleGetProductDetail = () => { },
    handleCart = () => { },
    outlet = {},
    order = {}
}) => {
    const navigate = useNavigation();
    return (
        <>
            <div className="mx-4 mt-4">
                <div className="text-gray-900 text-sm font-semibold">
                    Ringkasan Pesanan
                </div>
                <div className="mt-4">
                    {cart?.item?.map((item, index) => {
                        return (
                            <CartDetail
                                key={index}
                                data={item}
                                index={index}
                                handleGetProductDetail={handleGetProductDetail}
                                handleCart={handleCart}
                            />
                        );
                    })}
                </div>
            </div>
            <div className="border-b-1 border-solid pb-2 border-gray-200" />
            <div className="flex justify-between px-4 my-4 items-center pb-4 border-gray-200">
                <div>
                    <div className="text-sm text-gray-900 font-semibold">
                        Tambah Lagi?
                    </div>
                    <div className="text-xs text-gray-500 pt-1 font-thin">
                        Ingin menambahkan yang lain? Tambah menu lainnya
                    </div>
                </div>
                <button
                    id="summary_add_more_product"
                    className="bg-white border-solid border-1 border-[var(--rose-violet)] py-1.5 px-6 text-xs font-semibold text-[var(--rose-violet)] rounded-md min-w-fit"
                    onClick={() => navigate.push(`/ufood-x/${outlet?.storeSlug}/${cleanText(order?.selectedOrderType?.av_name)}`)}
                >
                    Tambah
                </button>
            </div>
        </>
    );
};

export default ProductOption;